import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout implements AfterViewInit {
  @ViewChild('contentArea')
  private contentArea?: ElementRef<HTMLDivElement>;

  private readonly router = inject(Router);

  ngAfterViewInit(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.contentArea?.nativeElement.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
  }
}